import React from 'react'
import { Link } from 'react-router-dom'
import { Home, ArrowLeft, StickyNote } from 'lucide-react'

/**
 * 404 Not Found Page Component
 * 
 * Displayed when users navigate to a route that doesn't exist.
 */
const NotFoundPage = () => {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <div className="text-center">
          {/* Icon */}
          <StickyNote className="mx-auto h-16 w-16 text-gray-400" />
          
          {/* 404 */}
          <h1 className="mt-6 text-6xl font-bold text-gray-900">404</h1>
          
          {/* Message */}
          <h2 className="mt-4 text-2xl font-bold text-gray-900">
            Page not found
          </h2>
          
          <p className="mt-2 text-gray-600">
            Sorry, we couldn't find the page you're looking for.
          </p>
          
          {/* Actions */}
          <div className="mt-8 flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/dashboard"
              className="btn-primary inline-flex items-center"
            >
              <Home className="h-4 w-4 mr-2" />
              Go to Dashboard
            </Link>
            
            <button
              onClick={() => window.history.back()}
              className="btn-outline inline-flex items-center"
            >
              <ArrowLeft className="h-4 w-4 mr-2" />
              Go Back
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default NotFoundPage 